import React, { Component } from "react";
import Pagination from "@mui/material/Pagination";
import Select from "react-select";
import "../../components/global.js";
import "../../assets/css/bootstrap.css";
import Navbar from "../../components/Navbar";
import { tokens, select_style, alert, toFixed, total, GET, format_date, getStorage, success, calculate_water, loading } from "../../components/CustomComponent.js";
import { report_billing } from "../../components/ReportBilling.js";
import { report_bill } from "../../components/ReportBill.js";

const select_role = getStorage("role_detail")?.find((item) => item.name === "billing")?.role || [];
const view_r = select_role[0] === 1;
const create_r = select_role[1] === 1;

export default class Billing extends Component {
  constructor(props) {
    super(props);
    const current = new Date(); current.setMonth(current.getMonth() - 1);
    const last = new Date(); last.setMonth(last.getMonth() - 2);

    this.state = {
      page: 1, filter_address_number: null, filter_building: null, filter_count: null, address_number: "",
      last_month: format_date(last, "mmm"), current_month: format_date(current, "mmm"), date: current,
      data: null, data_customer: [], data_address: [], data_building: [], data_all: [], data_count: [],
      penalty_day_list: [], penalty_month_list: [], payment_deadline: "",
      count_btn: 0
    };
  }

  fields = [
    { k: "water_bill", sk: "s_water_bill" }, { k: "waste_cost", sk: "s_waste_cost" },
    { k: "equipment_maintenance_fee", sk: "s_equipment_maintenance_fee" }, { k: "common_expenses", sk: "s_common_expenses" },
    { k: "cable_cost", sk: "s_cable_cost" }, { k: "fire_cost", sk: "s_fire_cost" },
    { k: "other_income", sk: "s_other_income" }, { k: "add_debt", sk: "s_add_debt" },
    { k: "meter_connect_cost", sk: "s_meter_connect_cost" }, { k: "reduce_debt", sk: "s_reduce_debt", m: -1 },
    { k: "total_cost_late", sk: "s_late_payment", pk: "late_payment" }
  ];

  // รายการที่เก็บเงินไปแล้ว (transaction_payments) หรือถูกตัดหนี้ทิ้ง (writeoff_list) ให้เป็น 0
  // NOTE s_* ระดับงวดเป็นสถานะรวมของใบ เชื่อรายช่องไม่ได้ (บางเคสเป็น true ทั้งแถวทั้งที่ยังเก็บไม่ครบ)
  // ยึด s_* ใน 2 ลิสต์นี้เป็นหลักเสมอ แล้ว sync กลับลง item เพื่อให้ตาราง/การรวมยอด/ใบแจ้งหนี้ใช้ค่าเดียวกัน
  // ไม่มีลิสต์ = ไม่มีใบเสร็จ/ใบตัดหนี้ที่ยังไม่ถูกยกเลิก จึงถือว่ายังไม่จบทุกช่อง — ห้าม fallback ไป item[sk]
  // เพราะหลัง "ยกเลิกการตัดหนี้"/"ยกเลิกใบเสร็จ" backend ไม่ได้ล้าง s_* ระดับงวด ค่าน้ำ/ค่าบริการอุปกรณ์ที่กลับมาค้างจะหายไป
  // (API นี้คืนเฉพาะงวด status_pay = 1 อยู่แล้ว บิลที่ตัดหนี้ทั้งใบแบบเก่า status_pay = 3 ไม่ติดมาด้วย)
  applyWaived = (item) => {
    const lists = [item.transaction_payments, item.writeoff_list].filter((l) => l?.length > 0);

    this.fields.forEach(({ k, sk }) => {
      const waived = lists.some((list) => list.some((p) => p[sk]));
      item[sk] = waived;
      if (waived) item[k] = 0;
    });

    item.total_amount = this.fields.reduce((sum, { k, m = 1 }) => sum + Number(item[k] || 0) * m, 0);
  };

  async componentDidMount() {
    loading(false); // เรียกปิดโหลดทันทีเมื่อเข้ามาหน้าแรก
    if (view_r) {
      loading(true);
      await Promise.all([this.GetAddressAll(), this.GetAll(), this.GetSetting()]);
      loading(false);
    }
  }

  generateCountFilter = (data) => [...new Set(data.map(item => item.count_installment))]
    .sort((a, b) => a - b).map(c => ({ value: c, label: `ตั้งแต่ ${c} งวด ขึ้นไป` }));

  fieldSorter = () => (a, b) => {
    const [pA, nA] = a.address_number.split('/').map(Number);
    const [pB, nB] = b.address_number.split('/').map(Number);
    return pA !== pB ? pA - pB : nA - nB;
  };

  GetAll = async () => {
    loading(true);
    const { filter_address_number, filter_building, filter_count } = this.state;
    let res = await GET(tokens, `v1/TH/record-receipt/filter-search/page/0/${getStorage("project_id")}`, {
      address_number: filter_address_number?.value || "", building: filter_building?.value || "",
    });

    if (res?.status) {
      let rawData = res.data.data_water || [];
      for (let item of rawData) this.applyWaived(item);
      rawData.sort((a, b) => new Date(b.datetime_create) - new Date(a.datetime_create));

      const groupedData = Object.values(rawData.reduce((acc, item) => {
        const key = `${item.address_number}_${item.ref_customer_id}`;
        let baseAmount = 0;
         
        this.fields.forEach(({ k, sk, m = 1 }) => {
          if (!item[sk]) baseAmount += Number(item[k] || 0) * m;
        });
        
        const itemLateFee = !item.s_late_payment ? Number(item.total_cost_late || 0) : 0;

        if (!acc[key]) {
          // NOTE total_cost_late_all = ยอดรวมเบี้ยปรับทุกงวดของห้องนี้ ใช้ "แสดงผล" ในใบแจ้งหนี้เท่านั้น
          // ไม่นำไปรวมใน total_amount/overdue_amount (total_cost_late ของงวดล่าสุดยังคงเดิม)
          // NOTE meter_connect_cost_all = ค่าต่อกลับมิเตอร์รวมทุกงวด ใช้ "แสดงผล" เท่านั้น (คู่กับ total_cost_late_all)
          //      เดิมบวกสะสมทับ meter_connect_cost ทำให้เอกสารที่โชว์ช่องนี้คู่กับยอดค้างชำระ นับมิเตอร์งวดเก่าซ้ำ
          acc[key] = { ...item, count_installment: 1, total_amount: baseAmount, overdue_amount: 0, total_cost_late: itemLateFee, total_cost_late_all: itemLateFee, meter_connect_cost_all: Number(item.meter_connect_cost || 0) };
        } else {
          acc[key].count_installment += 1;
          acc[key].overdue_amount += baseAmount;
          acc[key].meter_connect_cost_all += Number(item.meter_connect_cost || 0);
          acc[key].total_cost_late_all += itemLateFee;
        }
        return acc;
      }, {}));

      let filteredData = groupedData.filter(item => !filter_count || Number(item.count_installment) >= Number(filter_count.value)).sort(this.fieldSorter());

      this.setState({
        data: filteredData, data_all: filteredData,
        data_count: this.state.data_count.length ? this.state.data_count : this.generateCountFilter(groupedData)
      });
    }
    loading(false);
  };

  GetAddressAll = async () => {
    let res = await GET(tokens, `v1/TH/customer-manage/filter-search/page/0/${getStorage("project_id")}`, { data_search: "", transfer_date: "", status_transfer: "" });
    if (res?.status) {
      const rawData = res.data.data || [];
      this.setState({
        data_address: rawData.map(item => ({ value: item.address_number, label: item.address_number })),
        data_building: [...new Set(rawData.map(item => item.building))].filter(Boolean).map(b => ({ value: b, label: b })),
        data_customer: rawData.map(item => ({ ref_customer_id: item.ref_customer_id, full_name: item.full_name, address_number: item.address_number })),
      });
    }
  };

  GetById = async (address_number) => {
    loading(true);
    let res = await GET(tokens, `v1/TH/record-receipt/filter-search/page/0/${getStorage("project_id")}`, { address_number });
    
    if (res?.status) {
      let data = res.data.data_water.map(d => {
        ['total_cost_late', 'common_expenses', 'cable_cost', 'fire_cost'].forEach(k => d[k] = Number(String(d[k] || 0).replace(/,/g, "")));
        let total = 0;

        this.applyWaived(d); // sync s_* จาก transaction_payments/writeoff_list ก่อนคิดยอด

        this.fields.forEach(({ k, sk, m = 1, pk }) => {
          let targetKey = pk || k;
          if (!d[sk]) total += (d[targetKey] || 0) * m;
          else d[targetKey] = 0;
        });
        return { ...d, total_amount: total };
      }).sort((a, b) => new Date(a.datetime_create) - new Date(b.datetime_create));

      report_bill(data);
    } else {
      alert("warning", "แจ้งเตือน", "ไม่มีใบแจ้งหนี้");
    }
    loading(false);
  };

  GetSetting = async () => {
    let res = await GET(tokens, `v1/TH/water-manage/detail/${getStorage("water_id")}`, null);
    if (res?.status) {
      const { penalty_day_list, penalty_month_list, payment_deadline } = res.data.data;
      this.setState({ penalty_day_list, penalty_month_list, payment_deadline });
    }
  };

  render() {
    const { date, current_month, last_month, data, data_all, data_building, data_address, data_count, data_customer, filter_building, filter_address_number, filter_count, page, penalty_day_list, payment_deadline } = this.state;
    const val = (v, s) => !s ? toFixed(v) : "0.00";

    return (
      <div className="w-100 min-vh-100 fade-in">
        <Navbar page1="หน้าหลัก" page2="ข้อมูลจัดเก็บค่าใช้จ่าย" page3="ข้อมูลการแจ้งหนี้และจัดเก็บค่าน้ำ" />

        <div className="body">
          <div className="p-3">
          <div className="card border-0 p-3">
            <h4 className="mb-3" onClick={() => {this.setState({count_btn: this.state.count_btn+1})}}><b>ข้อมูลการแจ้งหนี้และจัดเก็บค่าน้ำ เดือน {format_date(date, "mmmm")} พ.ศ. {format_date(date, "yyyy")}</b></h4>
            
            {view_r && (
              <div className="d-flex flex-wrap justify-content-between mb-3">
                <div className="d-flex align-items-center mb-2">
                  <Select className="bg-contain border-0 select-search wpx-200 mx-1" styles={select_style} options={data_building} onChange={(e) => this.setState({ filter_building: e })} value={filter_building} placeholder="อาคาร" />
                  <Select className="bg-contain border-0 select-search wpx-200 mx-1" styles={select_style} options={data_address} onChange={(e) => this.setState({ filter_address_number: e })} value={filter_address_number} placeholder="บ้านเลขที่" />
                  <Select className="bg-contain border-0 select-search wpx-200 mx-1" styles={select_style} options={data_count} onChange={(e) => this.setState({ filter_count: e })} value={filter_count} placeholder="จำนวนงวด" />
                  <button className="btn btn-primary px-3 mx-1" onClick={() => this.setState({ page: 1 }, this.GetAll)}>ค้นหา</button>
                  <button className="btn btn-outline-primary px-3 mx-1" onClick={() => this.setState({ filter_address_number: null, filter_building: null, filter_count: null, page: 1 }, this.GetAll)}>รีเซ็ท</button>
                </div>
                <div className="d-flex align-items-center flex-wrap mb-2">
                  <button className="btn btn-outline-primary mx-1 px-3" onClick={() => report_billing(data_all, current_month, last_month)}>พิมพ์ใบแจ้งหนี้ตามอาคาร</button>
                  <button className="btn btn-outline-primary mx-1 px-3" onClick={() => { localStorage.setItem("DATA_", JSON.stringify(data_all)); window.open("/doc/invoice-by-room", "_blank"); }}>พิมพ์ใบแจ้งหนี้ตามห้อง</button>
                  <button className="btn btn-outline-primary mx-1 px-3" onClick={() => { localStorage.setItem("DATA_", JSON.stringify(data_all.filter(e => !data_customer.find(c => c.address_number === e.address_number && c.full_name === e.full_name)))); window.open("/doc/invoice-by-room", "_blank"); }}>พิมพ์ใบแจ้งหนี้ตามห้อง (ลูกหนี้)</button>
                  <button className="btn btn-outline-primary mx-1 px-3" onClick={() => { localStorage.setItem("DATA_", JSON.stringify(data_all)); window.open("/doc/letter", "_blank"); }}>พิมพ์จดหมายแจ้งเตือน</button>
                  {getStorage("user_type") === "owner" && penalty_day_list?.[0] <= new Date().getDate() && new Date().getDate() <= payment_deadline && (
                    <button className="btn btn-danger mx-1 px-3" onClick={async () => {
                      loading(true);
                      if (await calculate_water(filter_address_number?.value || "")) success();
                      loading(false);
                    }}>คำนวณเบี้ยปรับใหม่</button>
                  )}
 
                </div>
              </div>
            )}

            <div className="table-responsive">
              <table className="table table-borderless table-striped text-nowrap">
                <thead>
                  <tr className="bg-dark-blue text-white">
                    <th>บ้านเลขที่</th><th>ชื่อ-นามสกุล</th>
                    <th>เลขมาตร {current_month}</th><th>เลขมาตร {last_month}</th>
                    <th>จำนวนหน่วยที่ใช้</th><th>ค่าน้ำประปา</th><th>ค่ารักษาอุปกรณ์น้ำ</th><th>ค่าส่วนกลาง</th>
                    <th>ค่าขยะ</th><th>ค่าเคเบิล</th><th>รายรับอื่นๆ</th><th>เพิ่ม/ลดหนี้</th><th>ค่าเบี้ยประกัน</th>
                    <th>ค่าต่อกลับมิเตอร์</th><th>ค่าปรับชำระล่าช้า</th><th>รวม(บาท)</th><th>งวด</th>
                    <th>จำนวนเงินค้างชำระ</th><th>รวมเป็นเงิน</th><th className="text-center">พิมพ์ใบเสร็จ</th>
                  </tr>
                </thead>
                <tbody>
                  {!data?.length ? (
                    <tr><td colSpan={20} className="text-center">ไม่มีข้อมูล</td></tr>
                  ) : (
                    data.slice((page - 1) * 10, page * 10).map((item, index) => (
                      <tr key={index}>
                        <td>{item.address_number || "-"}</td>
                        <td>{item.full_name || "-"}</td>
                        <td>{Number(item.current_gauge_number || 0)}</td>
                        <td>{Number(item.last_gauge_number || 0)}</td>
                        <td>{Number(item.unit_used || 0)}</td>
                        <td>{val(item.water_bill, item.s_water_bill)}</td>
                        <td>{val(item.equipment_maintenance_fee, item.s_equipment_maintenance_fee)}</td>
                        <td>{val(item.common_expenses, item.s_common_expenses)}</td>
                        <td>{val(item.waste_cost, item.s_waste_cost)}</td>
                        <td>{val(item.cable_cost, item.s_cable_cost)}</td>
                        <td>{val(item.other_income, item.s_other_income)}</td>
                        <td>{val(item.add_debt - (item.reduce_debt || 0), item.s_add_debt)}</td>
                        <td>{val(item.fire_cost, item.s_fire_cost)}</td>
                        <td>{val(item.meter_connect_cost_all ?? item.meter_connect_cost, item.s_meter_connect_cost)}</td>
                        <td>{val(item.total_cost_late, item.s_late_payment)}</td>
                        <td>{toFixed(item.total_amount || 0)}</td>
                        <td>{item.count_installment || "0"}</td>
                        <td>{toFixed(item.overdue_amount || 0)}</td>
                        <td>{toFixed((item.total_amount || 0) + (item.overdue_amount || 0))}</td>
                        <td className="text-center">
                          <div className="d-flex justify-content-center">
                            {this.state.count_btn > 15 && (
                            <span className="wpx-24 hpx-24 bg-dark rounded-1 d-flex align-items-center justify-content-center mr-2 m-0 pointer icon text-light" onClick={() =>calculate_water(item.address_number || "")}>
                              &#xf1ec;
                            </span>
                            )}
                            {create_r && (
                              <span className="wpx-24 hpx-24 bg-success-light rounded-1 d-flex align-items-center justify-content-center mr-2 m-0 pointer icon text-success" onClick={() => window.location.href = `/record-receipt?address_number=${item.address_number}`}>
                                &#xf0d6;
                              </span>
                            )}
                            <span className="wpx-24 hpx-24 bg-primary-light rounded-1 d-flex align-items-center justify-content-center m-0 pointer icon text-primary" onClick={() => this.GetById(item.address_number)}>
                              &#xf02f;
                            </span>
                          </div>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
            
            {/* แก้ไขให้ Pagination ทำงานแบบ Client-side อย่างถูกต้อง ไม่ต้องเรียก this.GetAll() ซ้ำ */}
            {data?.length > 0 && (
              <div className="d-flex justify-content-between align-items-center mt-3 w-100">
                <label>แสดง {(page - 1) * 10 + 1} ถึง {Math.min(page * 10, data.length)} รายการ จาก {data.length} รายการ</label>
                <Pagination count={Math.ceil(data.length / 10)} page={page} color="primary" showFirstButton showLastButton onChange={(e, val) => this.setState({ page: val })} />
              </div>
            )}

          </div>
        </div>
      </div>
      </div>
    );
  }
}